import { useState, useCallback } from "react";

interface OneStoryOnlyWarningModalHandle {
  isOpen: boolean;
  open(): void;
  close(): void;
}

export const useOneStoryOnlyWarningModal =
  (): OneStoryOnlyWarningModalHandle => {
    const [isOpen, setOpen] = useState(false);
    const open = useCallback(() => {
      setOpen(true);
    }, []);
    const close = useCallback(() => {
      setOpen(false);
    }, []);

    return {
      isOpen,
      open,
      close,
    };
  };
